import * as React from "react";

const ExportCircleShape = (props: { color: string }): JSX.Element => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="35.818" height="47.818" viewBox="0 0 47.318 47.318">
            <defs>
                <filter id="Path_1173" x="0" y="0" width="47" height="47" filterUnits="userSpaceOnUse">
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="1.5" result="blur" />
                    <feFlood floodOpacity="0.161" />
                    <feComposite operator="in" in2="blur" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            <g id="export_icon" transform="translate(4.5 2.5)">
                <g id="Group_8231" data-name="Group 8231" transform="translate(-633 -570)">
                    <g id="Group_2701" data-name="Group 2701" transform="translate(633 570)">
                        <g transform="matrix(1, 0, 0, 1, -4.5, -2.5)" filter="url(#Path_1173)">
                            <path
                                id="Path_1173-2"
                                data-name="Path 1173"
                                d="M171.86,212.13a19,19,0,1,1-19,19,19,19,0,0,1,19-19Z"
                                transform="translate(-148.36 -209.63)"
                                fill={props.color}
                            />
                        </g>
                    </g>
                </g>
                <g id="export" transform="translate(8 4.659)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 4.25C12.4142 4.25 12.75 4.58579 12.75 5V13.5L15.55 11.4C15.8814 11.1515 16.3515 11.2186 16.6 11.55C16.8485 11.8814 16.7814 12.3515 16.45 12.6L12.45 15.6C12.1833 15.8 11.8167 15.8 11.55 15.6L7.55 12.6C7.21863 12.3515 7.15147 11.8814 7.4 11.55C7.64853 11.2186 8.11863 11.1515 8.45 11.4L11.25 13.5V5C11.25 4.58579 11.5858 4.25 12 4.25ZM4 14.25C4.41421 14.25 4.75 14.5858 4.75 15V18.25H19.25V15C19.25 14.5858 19.5858 14.25 20 14.25C20.4142 14.25 20.75 14.5858 20.75 15V19C20.75 19.4142 20.4142 19.75 20 19.75H4C3.58579 19.75 3.25 19.4142 3.25 19V15C3.25 14.5858 3.58579 14.25 4 14.25Z"
                        fill="#fff"
                        stroke="#fff"
                        strokeWidth="1"
                    />
                </g>
            </g>
        </svg>
    );
};

export default ExportCircleShape;
